import { API_REFERENCE } from '../utilities/constant_api';
import { jsonGet } from '../components/ajax';

const taskDetailsMainSection = $('.task-details-main-section');
const taskDetailsSection = $('.display-task-details');
const patientConsentSection = '.patient-consent-section';
const logbookSection = '.log-book-section';
const patientDocs = '.patient-document-text';
const summaryDocs = '.order-document-text';
const outandingSection = '.outstanding-steps-details-section';
const errorMessage = $('.confirm-global-error-text').text();
const successResponse = 'SUCCESS';
const cartBadgeSpan = '.js-mini-cart-count .badge';
const cartInitialValue = '0';
const checkoutOrderConfirmation = {
  getTasks() {
    $('.order-confirmation__title-print').css('pointer-events', 'none');
    let mainUrl = window.location.href;
    if (mainUrl.indexOf('checkout/orderConfirmation') > -1) {
      let taskURL =
        ACC.config.encodedContextPath +
        API_REFERENCE.orderConfirmation.getOrderProcessingDocumentsUrl +
        mainUrl.substring(mainUrl.lastIndexOf('/') + 1);
      jsonGet(taskURL)
        .then(data => {
          let formattedResponse = JSON.parse(data);
          if (formattedResponse.errorMessage === null) {
            $('.order-confirmation__title-print').css('pointer-events', 'auto');
            if (formattedResponse.hasShippingHold === true) {
              $('.shipping-hold-error').removeClass('hidden');
            }
            if (
              formattedResponse.outStandingSteps !== null &&
              formattedResponse.outStandingSteps.length > 0
            ) {
              formattedResponse.outStandingSteps.forEach(element => {
                if (
                  $('.outstanding-steps-details-section li').hasClass(element)
                ) {
                  $('.' + element).removeClass('hidden');
                }
              });
            }else{
              taskDetailsMainSection.parent('.order-confirmation').hide();
            }
          } else {
            let orderErrorMessage;
            if (formattedResponse.errorMessage === 'FAILURE') {
              orderErrorMessage = errorMessage;
            } else {
              orderErrorMessage = formattedResponse.errorMessage;
            }
            $('.global-error-message-container')
              .removeClass('hidden')
              .find('.generic-error-text')
              .text(orderErrorMessage);
            taskDetailsMainSection.find(summaryDocs).removeClass('hidden');
          }
          taskDetailsSection
            .parents('.task-details-main-section')
            .removeClass('hidden');
          $('.task-section-loading').addClass('hidden');
        })
        .catch(error => {
          $('.global-error-message-container')
            .removeClass('hidden')
            .find('.generic-error-text')
            .text(errorMessage);
          taskDetailsMainSection.find(summaryDocs).removeClass('hidden');
          taskDetailsSection
            .parents('.task-details-main-section')
            .removeClass('hidden');
          $('.task-section-loading').addClass('hidden');
        });
    }
  },
  removeCartFromSession() {
    let mainUrl = window.location.href;
    if (mainUrl.indexOf('checkout/orderConfirmation') > -1) {
      let removeCartFromSessionURL =
        ACC.config.encodedContextPath +
        API_REFERENCE.orderConfirmation.removeCartFromSession;
      jsonGet(removeCartFromSessionURL).then(data => {
        if (data == successResponse) {
          $(cartBadgeSpan).text(cartInitialValue);
          console.log(data);
        }
      });
    }
  },
  init() {
    this.getTasks();
  }
};
checkoutOrderConfirmation.init();
export default checkoutOrderConfirmation;
